import {useEffect, useState} from 'react'
import {VehicleModalHeader} from './VehicleModalHeader'
import {VehicleModalFormWrapper} from './vehicleModalFormWrapper'


const VehicleModal = ({user, setShowEditModal, getUser, setVehicle, customerDetails, hide=false}) => {
  const [confirmationModal, setConfirmationModal] = useState(false)

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])



  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <VehicleModalHeader user={user} setShowEditModal={setShowEditModal} setVehicle={setVehicle} getUser={getUser} hide={hide} setConfirmationModal={setConfirmationModal} confirmationModal={confirmationModal} />
            {/* begin::Modal body */}
            <div className={`modal-body scroll-y mx-5  mx-xl-15 my-7`}>
              <VehicleModalFormWrapper user={user} setShowEditModal={setShowEditModal} getUser={getUser} setVehicle={setVehicle} customerDetails={customerDetails} hide={hide} setConfirmationModal={setConfirmationModal} confirmationModal={confirmationModal} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {VehicleModal}
